import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const cone = `${CDN_URL}common/cone.svg`;

const NotFoundStyle = styled.div`
	color: ${props => props.theme.defaultFontColor};
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 20vh;
	img {
		width: 150px;
		height: 200px;
	}
	.lost-links {
		display: flex;
		flex-direction: column;
	}
	.main-heading {
		color: ${props => props.theme.Med_Rust};
	}
	.sub-heading {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const NotFound = () => {
	return (
		<NotFoundStyle>
			<img src={cone} />
			<div className='main-heading heading60'>Oops! You seem to be lost.</div>
			<div className='sub-heading heading70'>Here are some helpful links:</div>
			<div className='lost-links'>
				<Link to='/portal' className='body10'>
					Home
				</Link>
				<Link to='/login' className='body10'>
					Login
				</Link>
			</div>
		</NotFoundStyle>
	);
};
